import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Settings } from '../../models/app.settings.model';
import { AppSettings } from '../../models/app.settings';

@Component({
  selector: 'app-flags-menu',
  templateUrl: './flags-menu.component.html',
  styleUrls: ['./flags-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FlagsMenuComponent implements OnInit {
  public settings: Settings;
  private languageChangeStarted = false;

  constructor(public appSettings: AppSettings) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {}

  onMenuItemClicked(event: Event, language: string) {
    event.preventDefault();
    event.stopPropagation();
    if (this.languageChangeStarted) {
      return;
    }
    this.languageChangeStarted = true;
    this.appSettings.setLanguage(language);
    window.location.reload();
  }
}
